import { Box, Typography } from "@mui/material";
import { ITheme } from "../../utils/theme";
import { PopupMessage } from "../PopupMessage";
import { boxStyle, boxWrapperStyle } from "./styled";

interface IAvailabelityDisclaimerProps {
  handleClick: () => void,
}

export const AvailabelityDisclaimer: React.FC<IAvailabelityDisclaimerProps> = ({ handleClick }) => (
  <PopupMessage title="Total Available Legend:" onClose={handleClick}>
    <Box sx={boxWrapperStyle}>
      <Box sx={{ ...boxStyle, background: (theme: ITheme) => theme.palette.green[100], border: '2px solid black' }} />
      <Typography>Assigned to Job</Typography>
    </Box>
    <Box sx={boxWrapperStyle}>
      <Box sx={{ ...boxStyle, background: (theme: ITheme) => theme.palette.green[200] }} />
      <Typography>Assigned to Job with same Dispatch Priority</Typography>
    </Box>
    <Box sx={boxWrapperStyle}>
      <Box sx={{ ...boxStyle, background: (theme: ITheme) => theme.palette.yellow[400] }} />
      <Typography>Assigned to Job with a Lower Dispatch Priority</Typography>
    </Box>
    <Box sx={boxWrapperStyle}>
      <Box sx={{ ...boxStyle, background: (theme: ITheme) => theme.palette.yellow[50] }} />
      <Typography>Assigned to Job with a Higher Dispatch Priority</Typography>
    </Box>
    <Box sx={boxWrapperStyle}>
      <Box sx={{ ...boxStyle, background: (theme: ITheme) => theme.palette.grey[900] }} />
      <Typography>Not Eligible to work the Shift</Typography>
    </Box>
  </PopupMessage>
);
